import { PINNED_ASSET_SLUG } from "@/config/game";
import { useTranslation } from "@repo/shared/i18n";

import { BaseEvoPopup } from "./BaseEvoPopup";

interface ResetToWebAppStatePopupProps {
  onClose: () => void;
  onComplete: () => void;
}

/** Confirms putting every state back to what the last club import detected. */
export const ResetToWebAppStatePopup = ({
  onClose,
  onComplete,
}: ResetToWebAppStatePopupProps) => {
  const { t } = useTranslation(["evolutions", "common"]);
  return (
    <BaseEvoPopup
      posLabel={t("popups.resetWebApp.confirm")}
      onPositive={onComplete}
      handleOnClose={onClose}
      title={t("popups.resetWebApp.title")}
      imageUrl={`${import.meta.env.VITE_APP_ASSETS_BASE_URL}/${PINNED_ASSET_SLUG}/evolutions-hub/reset-to-web-app-v2.png`}
    >
      <p className="font-semibold text-foreground">
        {t("popups.resetWebApp.question")}
      </p>
      <p>{t("popups.resetWebApp.body")}</p>
    </BaseEvoPopup>
  );
};
